module.exports = __webpack_public_path__ + "img/invoice-de-male-wm-banner-sh.a4b58c3f.png";